var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '../../../../strings/i18n/i18n';
import { Tab, Tabs } from 'syf-component-library/ui/patterns/Tabs';
import styled from 'styled-components';
import { fontWeights, spacing } from 'syf-component-library/defaultTheme';
import theme from '../../../../theme';
import query from 'syf-component-library/const/mediaQueries';
import DisputeDetails from '../DisputeDetails';
import DisputeHistory from '../DisputeHistory';
var DisputeInfoTab = styled(Tab)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n\n  & > * {\n    text-transform: uppercase;\n    font-weight: ", ";\n    padding: ", "px ", "px;\n\n    @media ", " {\n      padding: ", "px ", "px;\n    }\n  }\n"], ["\n  color: ", ";\n\n  & > * {\n    text-transform: uppercase;\n    font-weight: ", ";\n    padding: ", "px ", "px;\n\n    @media ", " {\n      padding: ", "px ", "px;\n    }\n  }\n"])), theme.pallete.button.text, fontWeights.bold, spacing.medium, spacing.small, query.greaterThanMedium, spacing.medium, spacing.large);
var DisputeTabs = styled(Tabs)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n"], ["\n  border-bottom: 1px solid ", ";\n"])), theme.colors.lightGrey);
var DisputeInfoTabs = function () {
    return (_jsxs(DisputeTabs, __assign({ "data-cy": "dispute-info-tabs", defaultTab: 0 }, { children: [_jsx(DisputeInfoTab, __assign({ label: t('disputeDetails.disputeDetails'), id: "tab1" }, { children: _jsx(DisputeDetails, {}) })), _jsx(DisputeInfoTab, __assign({ label: t('disputeDetails.disputeHistory'), id: "tab2" }, { children: _jsx(DisputeHistory, {}) }))] })));
};
export default DisputeInfoTabs;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map